import React from "react";
import { useTranslation } from "react-i18next";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="absolute top-4 right-4 z-50">
      <button onClick={() => changeLanguage("es")} className="mx-1 px-2 py-1 bg-[#1c1c1c] text-white rounded">ES</button>
      <button onClick={() => changeLanguage("en")} className="mx-1 px-2 py-1 bg-[#1c1c1c] text-white rounded">EN</button>
    </div>
  );
};

export default LanguageSwitcher;
